import { createApp, h } from "vue"
import { VueQueryPlugin } from "@tanstack/vue-query"
import ElementPlus from "element-plus"
import "./styles/fonts.css"
import "./styles-deprecated/index.scss"
import "./styles/index.css"
import router from "./router"
import store from "@/store"
import { useUserStore } from "@/store/user-store"
import App from "./App.vue"
import sentryService from "@/services/sentry-service"
import trackClick from "@/services/analytics/directives/track-click"
import asclepiusConfig from "@common/config/asclepius-config"
import registerModule from "@/module-register"
import loginModuleRegister from "@/modules/login"
import memberManagementModuleRegister from "@/modules/member-management"
import occupationalHealthModuleRegister from "@/modules/occupational-health"
import subscriptionModuleRegister from "@/modules/subscription"
import workforceIntegrationsModule from "@/modules/workforce-integrations"
import { isEmbeddedContext } from "@common/services/embed-service"
import embedService from "@common/services/embed-service"
import { version } from "../package.json"

import { SERVER_URL } from "@/config"
import { queryClient } from "@/config/query-client"
import { configure as configureVeeValidate } from "vee-validate"
import { initializeVitePreloadErrorHandler } from "@common/services/vite-preload-error-service"
import { AppNameEnum } from "@vitable/asclepius-api-client-ts"

// Set shared Asclepius configuration
asclepiusConfig.setAsclepiusServerUrl(SERVER_URL)
asclepiusConfig.setAppInfo({ appName: AppNameEnum.CompanyDashboard, appVersion: version })

const app = createApp({
  async created() {
    if (!isEmbeddedContext()) {
      await useUserStore().init()
    }
  },
  render: () => h(App)
})

// * Add Directives
app.directive("track-click", trackClick)

// register modules
registerModule(loginModuleRegister)
registerModule(memberManagementModuleRegister)
registerModule(occupationalHealthModuleRegister)
registerModule(subscriptionModuleRegister)
registerModule(workforceIntegrationsModule)

embedService.initializeEmbedContext(app)

// * Add libraries
app.use(VueQueryPlugin, { queryClient }).use(router).use(store).use(ElementPlus)

configureVeeValidate({
  validateOnBlur: false,
  validateOnChange: true,
  validateOnInput: false,
  validateOnModelUpdate: false
})

// MUST BE CALLED BEFORE app.mount
sentryService.initializeSentry(app)
initializeVitePreloadErrorHandler({ router })

app.mount("#app")
